// extracted by mini-css-extract-plugin
export default {"contentSection":"station-content-section-module--contentSection--39c41","title":"station-content-section-module--title--e148a","text":"station-content-section-module--text--41800"};